var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"coverage-container"},[_c('div',{staticClass:"main-content"},[_c('span',{staticClass:"usage-report",on:{"click":_vm.getBackFlow}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }